import SharedWithGroupsContainer from './SharedWithGroupsContainer';
export default SharedWithGroupsContainer;
